/**
 * Pre-compiled de messages for FieldErrors
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  duplicateValue: `Dieser Wert wird bereits verwendet. Er muss eindeutig sein.`,
  emptyValue: `Dieses Feld darf nicht leer sein.`,
  invalidFormat: `Bitte geben Sie ein gültiges Format ein.`,
  invalidFractionalNumber: `Eine ganze Zahl ist erforderlich.`,
  invalidFromServer: `Die Servervalidierung ist fehlgeschlagen. Bitte überprüfen Sie Ihre Eingabe.`,
  invalidNegativeNumber: `Negative Zahlen werden nicht unterstützt.`,
  invalidValue: `Der angegebene Wert ist ungültig.`,
  missingRequiredField: `Dies ist ein Pflichtfeld. Bitte geben Sie einen Wert ein.`,
  resourceNotFound: `Die angeforderte Ressource wurde nicht gefunden.`,
  valueAboveMaximum: `Der Wert muss kleiner oder gleich dem Höchstwert sein.`,
  valueBelowMinimum: `Der Wert muss größer oder gleich dem Mindestwert sein.`,
  valueBlocked: `Dieser Wert ist nicht erlaubt.`,
  valueOutOfRange: `Der Wert muss im akzeptablen Bereich liegen.`,
  valueTooLong: `Der Wert ist zu lang.`,
  valueTooShort: `Der Wert ist zu kurz.`,
};
